import { useEffect, useState } from 'react'
import { truncateNumber } from '../../../../../../utils/commonFunctions'
import ViewerSettings from '../../../../../CommonComponents/ViewerSettings'
import useUrlParams from '../../../../hooks/useUrlParams'
import { VIEW_TYPES } from '../../../../../../utils/constants'
import useViewer from '../../../../hooks/useViewer'
import { onSatelliteUpdate } from '../../../../hooks/cesiumUtils'

const OrbitAnimationTimeline = () => {
    const { viewer } = useViewer()
    const { scenario_id } = useUrlParams()

    const [coords, setCoords] = useState({ latitude: 0, longitude: 0, altitude: 0 });

    useEffect(() => {
        const liveSatelliteData = onSatelliteUpdate((data) => {
            setCoords({ latitude: data.lat, longitude: data.lon, altitude: data.alt });
        });
        return liveSatelliteData;
    }, []);

    return (
        <div className='hud__orbit__animation__timeline__container__wrapper'>
            <div className='hud__orbit__animation__timeline__container'>
                <div className='hud__orbit__animation__timeline__left__container'>
                    <div className='timeline__information__container'>
                        <span className='information__label'>Lat</span>
                        <span className='information__value'>{Math.round(coords.latitude * 100) / 100}</span>
                    </div>
                    <div className='timeline__information__container'>
                        <span className='information__label'>Long</span>
                        <span className='information__value'>{Math.round(coords.longitude * 100) / 100}</span>
                    </div>
                    <div className='timeline__information__container'>
                        <span className='information__label'>Altitude</span>
                        <span className='information__value'>{truncateNumber(coords.altitude, 2)}</span>
                    </div>
                </div>

            </div>
            <ViewerSettings className='hud__setting__button' disabled={!scenario_id} viewer={viewer} viewerId={scenario_id || '123'} viewType={VIEW_TYPES.SIMULATE} />
        </div>
    )
}

export default OrbitAnimationTimeline